<template>
  <div class="theme-config-management">
    <el-card>
      <div slot="header">
        <span>样式主题配置</span>
      </div>
      
      <el-form :model="form" ref="form" label-width="160px">
        <el-form-item label="案例悬停颜色">
          <el-color-picker v-model="form.caseHoverColor" show-alpha></el-color-picker>
          <span class="color-value">{{ form.caseHoverColor }}</span>
        </el-form-item>
        
        <el-form-item label="底部背景颜色">
          <el-color-picker v-model="form.footerBackgroundColor"></el-color-picker>
          <span class="color-value">{{ form.footerBackgroundColor }}</span>
        </el-form-item>
        
        <el-form-item label="版权区背景颜色">
          <el-color-picker v-model="form.copyrightBackgroundColor"></el-color-picker>
          <span class="color-value">{{ form.copyrightBackgroundColor }}</span>
        </el-form-item>
        
        <el-form-item label="预览效果">
          <div class="preview-box">
            <div class="preview-case" :style="{ backgroundColor: form.caseHoverColor }">
              案例悬停效果预览
            </div>
            <div class="preview-footer" :style="{ backgroundColor: form.footerBackgroundColor }">
              底部背景预览
            </div>
            <div class="preview-copyright" :style="{ backgroundColor: form.copyrightBackgroundColor }">
              版权区背景预览
            </div>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存配置</el-button>
          <el-button @click="resetToDefault">恢复默认主题</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ThemeConfigManagement',
  data() {
    return {
      form: {
        id: null,
        caseHoverColor: 'rgba(225, 56, 52, 0.7)',
        footerBackgroundColor: '#14679f',
        copyrightBackgroundColor: '#125688'
      },
      loading: false
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      try {
        const response = await this.$http.get('/config/theme')
        if (response.success && response.data) {
          this.form = { ...response.data }
        }
      } catch (error) {
        this.$message.error('加载配置失败')
        console.error('加载配置失败:', error)
      }
    },
    
    async submitForm() {
      this.loading = true
      try {
        const response = await this.$http.put('/config/theme', this.form)
        if (response.success) {
          this.$message.success('配置保存成功')
          this.loadConfig()
        } else {
          this.$message.error('配置保存失败: ' + response.message)
        }
      } catch (error) {
        this.$message.error('配置保存失败')
        console.error('配置保存失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    resetToDefault() {
      this.$confirm('确定要恢复默认主题吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.caseHoverColor = 'rgba(225, 56, 52, 0.7)'
        this.form.footerBackgroundColor = '#14679f'
        this.form.copyrightBackgroundColor = '#125688'
        this.$message.success('已恢复默认主题，请点击保存配置')
      }).catch(() => {})
    },
    
    resetForm() {
      this.loadConfig()
    }
  }
}
</script>

<style scoped>
.theme-config-management {
  max-width: 800px;
}

.color-value {
  margin-left: 15px;
  color: #666;
  font-family: monospace;
}

.preview-box {
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.preview-case,
.preview-footer,
.preview-copyright {
  padding: 20px;
  color: white;
  text-align: center;
  font-weight: bold;
}

.preview-case {
  background-size: cover;
  background-position: center;
}
</style>
